import React from 'react';
import IntestazioneSezione from '../components/comuni/IntestazioneSezione';
import ContiMedici from '../components/magazzino/ContiMedici';
import '../styles/Magazzino.css';

/**
 * Il conto prodotti del medico che sta guardando.
 *
 * PERCHE' UNA PAGINA A SE' E NON LA LINGUETTA DEL MAGAZZINO
 * Il Magazzino e' riservato ad admin e segreteria: un medico non ci
 * arriva ne' dal menu ne' dalla rotta. Senza questa pagina il permesso
 * «ciascuno vede il proprio conto» esisterebbe sul server e non avrebbe
 * nessuna strada per arrivarci - che e' la stessa cosa che non averlo.
 *
 * E' lo stesso componente della linguetta. Non e' una copia: a cambiare
 * e' chi risponde alla rotta, non il disegno. Il server manda a un medico
 * solo le sue righe e non manda `coordina`, quindi i comandi per
 * assegnare e travasare non compaiono - e non comparirebbero nemmeno se
 * qualcuno aprisse questa pagina con un altro ruolo, perche' a decidere
 * e' la risposta del server e non un controllo scritto qui.
 */
const MioContoProdotti = () => (
    <div className="mag-wrap">
        <IntestazioneSezione
            titolo="Il mio conto prodotti"
            sottotitolo="Quanto materiale ti è stato assegnato, quanto ne hai consumato e quanto ne resta"
        />
        <p className="mag-nota">
            Il prodotto sta in un magazzino solo: questo è un conto, non uno
            scaffale riservato. Nessuna unità ti viene impedita, e un residuo
            negativo <b>non blocca niente</b> — la procedura si registra
            comunque, e a fine mese si riassegna. Vedi soltanto il tuo conto:
            quello dei colleghi non passa da qui.
        </p>
        <ContiMedici soloMio />
    </div>
);

export default MioContoProdotti;
